import { User } from '../../types'
import { InventoryConfig } from '../../types/aptConfig'
import { AreaInspection, InventoryInspection } from '../../types/inspection'
import {
    InspectionActionTypes,
    SET_AREA_INSPECTION,
    SET_INVENTORY_CONFIG,
    SET_INVENTORY_INSPECTION,
} from './types'

export const setInventoryInspection = (
    inventoryInspection?: InventoryInspection,
): InspectionActionTypes => {
    return {
        type: SET_INVENTORY_INSPECTION,
        inventoryInspection: inventoryInspection,
    }
}

export const setInventoryConfig = (
    inventoryConfig?: InventoryConfig,
): InspectionActionTypes => {
    return {
        type: SET_INVENTORY_CONFIG,
        inventoryConfig: inventoryConfig,
    }
}

export const setAreaInspection = (
    areaInspection?: AreaInspection,
): InspectionActionTypes => {
    return {
        type: SET_AREA_INSPECTION,
        areaInspection: areaInspection,
    }
}
